var render = function () {
  var _vm$inspectionData, _vm$inspectionData$de, _vm$inspectionData2, _vm$inspectionData2$d, _vm$inspectionData3, _vm$inspectionData3$d, _vm$inspectionData4, _vm$inspectionData4$d, _vm$inspectionData5, _vm$inspectionData5$d, _vm$inspectionData6, _vm$inspectionData6$d, _vm$inspectionData7, _vm$inspectionData7$d, _vm$inspectionData8, _vm$inspectionData8$d, _vm$inspectionData9, _vm$inspectionData9$d, _vm$inspectionData10, _vm$inspectionData10$, _vm$inspectionData11, _vm$inspectionData11$, _vm$inspectionData12, _vm$selectedImage;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.inspectionData ? _c('el-dialog', {
    staticClass: "modal-income title-hide scrollable-dialog",
    attrs: {
      "width": "40%",
      "close-on-click-modal": false,
      "visible": _vm.visibleSync,
      "data-selector": "inspection-detail-view-modal"
    },
    on: {
      "update:visible": function ($event) {
        _vm.visibleSync = $event;
      }
    }
  }, [_c('el-card', {
    staticClass: "card-child-p-0 pb-4",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('p', {
    staticClass: "text-xs font-extrabold",
    attrs: {
      "data-selector": "adv-header-text"
    }
  }, [_vm._v("\n          Pickles Inspection\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content-wrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Inspector Name")]), _vm._v(" "), (_vm$inspectionData = _vm.inspectionData) !== null && _vm$inspectionData !== void 0 && (_vm$inspectionData$de = _vm$inspectionData.details) !== null && _vm$inspectionData$de !== void 0 && _vm$inspectionData$de.inspectorName ? _c('p', {
    staticClass: "text-xs mb-4 line-height-normal text-capitalize",
    attrs: {
      "data-selector": "adv-selected-type"
    }
  }, [_vm._v(_vm._s(_vm.inspectionData.details.inspectorName))]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Product Description")]), _vm._v(" "), (_vm$inspectionData2 = _vm.inspectionData) !== null && _vm$inspectionData2 !== void 0 && (_vm$inspectionData2$d = _vm$inspectionData2.details) !== null && _vm$inspectionData2$d !== void 0 && _vm$inspectionData2$d.productDescription ? _c('p', {
    staticClass: "text-xs mb-4 line-height-normal text-capitalize",
    attrs: {
      "data-selector": "adv-selected-type"
    }
  }, [_vm._v(_vm._s(_vm.inspectionData.details.productDescription))]) : _vm._e()])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Inspection Start")]), _vm._v(" "), (_vm$inspectionData3 = _vm.inspectionData) !== null && _vm$inspectionData3 !== void 0 && (_vm$inspectionData3$d = _vm$inspectionData3.details) !== null && _vm$inspectionData3$d !== void 0 && _vm$inspectionData3$d.inspectionStart ? _c('p', {
    staticClass: "text-xs mb-4 line-height-normal text-capitalize",
    attrs: {
      "data-selector": "adv-selected-type"
    }
  }, [_vm._v(_vm._s(_vm.format(new Date(_vm.inspectionData.details.inspectionStart), 'dd/MM/yyyy hh:mm aaa')))]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Inspection End")]), _vm._v(" "), (_vm$inspectionData4 = _vm.inspectionData) !== null && _vm$inspectionData4 !== void 0 && (_vm$inspectionData4$d = _vm$inspectionData4.details) !== null && _vm$inspectionData4$d !== void 0 && _vm$inspectionData4$d.inspectionEnd ? _c('p', {
    staticClass: "text-xs mb-4 line-height-normal text-capitalize",
    attrs: {
      "data-selector": "adv-selected-type"
    }
  }, [_vm._v(_vm._s(_vm.format(new Date(_vm.inspectionData.details.inspectionEnd), 'dd/MM/yyyy hh:mm aaa')))]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "border-t border-light-grey pt-4"
  }, [_c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Make")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs line-height-normal mb-4 text-capitalize",
    attrs: {
      "data-selector": "adv-selected-make"
    }
  }, [_vm._v(_vm._s((_vm$inspectionData5 = _vm.inspectionData) !== null && _vm$inspectionData5 !== void 0 && (_vm$inspectionData5$d = _vm$inspectionData5.details) !== null && _vm$inspectionData5$d !== void 0 && _vm$inspectionData5$d.make ? _vm.inspectionData.details.make : 'Not Available'))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Model")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs line-height-normal mb-4 text-capitalize",
    attrs: {
      "data-selector": "adv-selected-model"
    }
  }, [_vm._v(_vm._s((_vm$inspectionData6 = _vm.inspectionData) !== null && _vm$inspectionData6 !== void 0 && (_vm$inspectionData6$d = _vm$inspectionData6.details) !== null && _vm$inspectionData6$d !== void 0 && _vm$inspectionData6$d.model ? _vm.inspectionData.details.model : 'Not Available'))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Year")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs line-height-normal mb-4 text-capitalize",
    attrs: {
      "data-selector": "adv-selected-year"
    }
  }, [_vm._v(_vm._s((_vm$inspectionData7 = _vm.inspectionData) !== null && _vm$inspectionData7 !== void 0 && (_vm$inspectionData7$d = _vm$inspectionData7.details) !== null && _vm$inspectionData7$d !== void 0 && _vm$inspectionData7$d.year ? _vm.inspectionData.details.year : 'Not Available'))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Variant")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs line-height-normal mb-4 text-capitalize",
    attrs: {
      "data-selector": "adv-selected-model-type"
    }
  }, [_vm._v(_vm._s((_vm$inspectionData8 = _vm.inspectionData) !== null && _vm$inspectionData8 !== void 0 && (_vm$inspectionData8$d = _vm$inspectionData8.details) !== null && _vm$inspectionData8$d !== void 0 && _vm$inspectionData8$d.variant ? _vm.inspectionData.details.variant : 'Not Available'))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("VIN")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs line-height-normal mb-4 text-capitalize",
    attrs: {
      "data-selector": "adv-selected-year"
    }
  }, [_vm._v(_vm._s((_vm$inspectionData9 = _vm.inspectionData) !== null && _vm$inspectionData9 !== void 0 && (_vm$inspectionData9$d = _vm$inspectionData9.details) !== null && _vm$inspectionData9$d !== void 0 && _vm$inspectionData9$d.vin ? _vm.inspectionData.details.vin : 'Not Available'))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Registration")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs line-height-normal mb-4 text-capitalize",
    attrs: {
      "data-selector": "adv-selected-model-type"
    }
  }, [_vm._v(_vm._s((_vm$inspectionData10 = _vm.inspectionData) !== null && _vm$inspectionData10 !== void 0 && (_vm$inspectionData10$ = _vm$inspectionData10.details) !== null && _vm$inspectionData10$ !== void 0 && _vm$inspectionData10$.registration ? _vm.inspectionData.details.registration : 'Not Available'))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('p', {
    staticClass: "mb-2 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Vehicle Code")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs line-height-normal mb-4 text-capitalize",
    attrs: {
      "data-selector": "adv-selected-year"
    }
  }, [_vm._v(_vm._s((_vm$inspectionData11 = _vm.inspectionData) !== null && _vm$inspectionData11 !== void 0 && (_vm$inspectionData11$ = _vm$inspectionData11.details) !== null && _vm$inspectionData11$ !== void 0 && _vm$inspectionData11$.vehicleDataCode ? _vm.inspectionData.details.vehicleDataCode : 'Not Available'))])])])], 1)], 1), _vm._v(" "), _vm.inspection.details && _vm.inspection.details.length > 0 ? _c('div', {
    staticClass: "border-t border-light-grey pt-4"
  }, [_c('p', {
    staticClass: "mb-4 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Inspection Details")]), _vm._v(" "), _vm._l(_vm.gridRows, function (row, rowIndex) {
    return _c('el-row', {
      key: rowIndex,
      staticClass: "mb-4",
      attrs: {
        "gutter": 32
      }
    }, _vm._l(row, function (item, colIndex) {
      return _c('el-col', {
        key: colIndex,
        attrs: {
          "sm": 24,
          "lg": 12
        }
      }, [_c('div', {
        staticClass: "inline-block w-full"
      }, [_c('p', {
        staticClass: "mb-2 text-xs font-extrabold line-height-normal"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
        staticClass: "text-xs line-height-normal"
      }, [_vm._v("\n                " + _vm._s(item.value) + "\n              ")])])]);
    }), 1);
  })], 2) : _vm._e(), _vm._v(" "), (_vm$inspectionData12 = _vm.inspectionData) !== null && _vm$inspectionData12 !== void 0 && _vm$inspectionData12.medias && _vm.inspectionData.medias.length > 0 ? _c('div', {
    staticClass: "border-t border-light-grey pt-4"
  }, [_c('p', {
    staticClass: "mb-4 text-xs font-extrabold line-height-normal"
  }, [_vm._v("Images")]), _vm._v(" "), _vm._l(_vm.mediaGridRows, function (row, rowIndex) {
    return _c('el-row', {
      key: rowIndex,
      staticClass: "mb-4",
      attrs: {
        "gutter": 32
      }
    }, _vm._l(row, function (media, colIndex) {
      return _c('el-col', {
        key: colIndex,
        attrs: {
          "sm": 24,
          "lg": 12
        }
      }, [_c('div', {
        staticClass: "inline-block w-full"
      }, [_c('p', {
        staticClass: "mb-2 text-xs font-extrabold line-height-normal"
      }, [_vm._v(_vm._s(media.description || ("Image " + (rowIndex * 2 + colIndex + 1))))]), _vm._v(" "), media.content ? _c('div', {
        staticClass: "mt-2"
      }, [_c('img', {
        staticClass: "w-full rounded border cursor-pointer hover:opacity-80 transition-opacity",
        staticStyle: {
          "max-height": "200px",
          "object-fit": "contain"
        },
        attrs: {
          "src": media.content,
          "alt": media.description || 'Inspection Image'
        },
        on: {
          "click": function ($event) {
            return _vm.openImageModal(media);
          }
        }
      })]) : _c('p', {
        staticClass: "text-xs text-gray-500 italic"
      }, [_vm._v("No image content available")])])]);
    }), 1);
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "data-selector": "adv-close-btn"
    },
    on: {
      "click": function ($event) {
        return _vm.closeDialog();
      }
    }
  }, [_vm._v("Close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "image-modal",
    attrs: {
      "width": "80%",
      "visible": _vm.imageModalVisible,
      "close-on-click-modal": true,
      "center": ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.imageModalVisible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "image-modal-content"
  }, [(_vm$selectedImage = _vm.selectedImage) !== null && _vm$selectedImage !== void 0 && _vm$selectedImage.content ? _c('img', {
    staticClass: "modal-image",
    attrs: {
      "src": _vm.selectedImage.content,
      "alt": _vm.selectedImage.description || 'Inspection Image'
    }
  }) : _vm._e()])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }